import { PlayerResponse } from "./dto/auth.dto.js";

const TOKEN_KEY = 'player_auth_token';
const PLAYER_ID_KEY = 'player_id';

interface Session
{
  playerId: number | null;
  token: string | null;
}

function persistToken( token: string | null ): void
{
  if ( token ) localStorage.setItem( TOKEN_KEY, token );
  else localStorage.removeItem( TOKEN_KEY );
}

function persistPlayerId( id: number | null ): void
{
  if ( id !== null ) localStorage.setItem( PLAYER_ID_KEY, String( id ) );
  else localStorage.removeItem( PLAYER_ID_KEY );
}

export class AuthSessionStore
{
  private static _session: Session = { playerId: null, token: null };

  public static setFromPlayer( player: PlayerResponse ): void
  {
    this._session = { playerId: player.id, token: player.token };
    persistToken( player.token );
    persistPlayerId( player.id );
  }

  public static getToken(): string | null
  {
    return this._session.token ?? localStorage.getItem( TOKEN_KEY );
  }

  public static getPlayerId(): number | null
  {
    if ( this._session.playerId !== null ) return this._session.playerId;
    const stored = localStorage.getItem( PLAYER_ID_KEY );
    return stored ? Number( stored ) : null;
  }

  public static isLoggedIn(): boolean
  {
    return !!this.getToken();
  }

  public static clear(): void
  {
    this._session = { playerId: null, token: null };
    persistToken( null );
    persistPlayerId( null );
  }
}
